import React from 'react'
import { FormattedMessage } from 'react-intl'

import ScheduleTimerComponent from '../../../Webinar/components/ScheduleTimerComponent/ScheduleTimerComponent'
import { useLiveDataQuery } from '../../../global/blocs/useLiveData'
import {
  markWebinarTimePast,
  useHasBeenBroadcasting,
  useIsWebinarTimePast,
} from '../../useAudienceLiveState'

import './WaitingRoomCountdownComponent.scss'

const WaitingRoomCountdownComponent = () => {
  const { data: liveData } = useLiveDataQuery()
  const isHolding = useHasBeenBroadcasting()
  const isWebinarTimePast = useIsWebinarTimePast()

  return (
    <div className="waiting-room-countdown-component">
      {isHolding || isWebinarTimePast ? (
        <>
          <div className="starting-in">
            <FormattedMessage defaultMessage="Hold on" />
          </div>
          <div className="big-message">
            {isHolding ? (
              <FormattedMessage defaultMessage="Continuing shortly" />
            ) : (
              <FormattedMessage defaultMessage="Starting shortly" />
            )}
            {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
            {}
            ...
          </div>
        </>
      ) : (
        <>
          <div className="starting-in">
            <FormattedMessage defaultMessage="Starting in" />
          </div>
          <ScheduleTimerComponent
            startTimeEpoch={liveData?.live_date_epoch}
            renderOnlyTimer
            onLiveCountdownZero={markWebinarTimePast}
          />
        </>
      )}
    </div>
  )
}

export { WaitingRoomCountdownComponent }
